import React from 'react';
import PropTypes from 'prop-types';

class Switch extends React.Component{

    state = {
        checked: this.props.checked
    }


    handleChange = (e) => {
        this.setState({
            checked: e.target.checked
        });
        this.props.onChange(e.target.checked);
    };

    render() {
        return (
            <div className="flex-between switchDiv">
                <label>{this.props.label}</label>
                <label className="switch">
                    <input type="checkbox" checked={this.state.checked} onChange={(e) => this.handleChange(e)} />
                    <span className="slider round"></span>
                </label>
            </div>
        );
    }
}

Switch.propTypes = {
    checked: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
}

export default Switch;


/** WEBPACK FOOTER **
 ** ./src/components/ui/Switch.js
 **/